// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Ecaw","inputDescription":"styles_inputDescription__3d3B5"};